<div  *ngIf="notification" class="alert  d-flex align-items-center border-none alert-dismissible fade show" [ngClass]="notification.type" role="alert">
    <mat-icon>{{notification.icon}}</mat-icon>
    <div class="ms-2">
        {{notification.message}}
    </div>
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
  </div>